import React from 'react'
import css from './style.scss'
import cn from 'classnames'
import store from 'utils/store'
import {connect} from 'react-redux'
import {VideoLoading} from '../loading.js'
import AudioOffIcon from 'react-icons/lib/md/volume-off'
import AudioOnIcon from 'react-icons/lib/md/volume-up'

const ProgressBar=(props)=>{
  return(
    <div className={css.progress_bar}>
      <div className={cn(css.bar, props.progress===0 ? css.bar_stop : css.bar_animated)} style={{width:props.progress+"%"}}></div>
    </div>
  )
}
const MuteButton=(props)=>{
  return (
    <div className={css.mute_button} onClick={props.onClick}>
      {props.muted && <AudioOffIcon size={24}/>}
      {!props.muted && <AudioOnIcon size={24}/>}
    </div>
  )
}
class Video extends React.Component{
  constructor(props){
    super(props)
    this.state={
      progress:0,
      play:false,
      loading:true
    }
  }
  toggleMuted(e){
    store.dispatch({type:"MEDIA_MUTE", payload:!this.props.muted})
    e.preventDefault();
    e.stopPropagation()
    return false;
  }
  togglePlay(){
    this.setState({loading:false, play: !this.state.play}, ()=>{
        this.state.play ? this.refs.video.play() : this.refs.video.pause()
    })
  }
  componentWillReceiveProps(nextProps){
    if(nextProps.src!==this.props.src){
      this.setState({progress:0, loading:true, play:false})
    }
  }
  handleTimeUpdate(){
    this.setState({progress:this.refs.video.currentTime*100/this.refs.video.duration})
  }
  onLoad(){
    this.setState({loading:false})
  }
  calculateVideoDimensions=(meta={})=>{
    let currentHeight=document.body.clientWidth<800 ? 300 : 500;
    return {
      height:currentHeight+"px",
      width:(currentHeight*meta.width)/meta.height+"px"
    }
  }
  render(){
    let style=this.calculateVideoDimensions(this.props.meta)
    return (
        <div onClick={this.togglePlay.bind(this)} style={style} className={cn(css.media_container, css.video_container)}>
          <ProgressBar progress={this.state.progress}/>
          <video
            ref="video"
            autoloop="false"
            loop="loop"
            muted={this.props.muted}
            preload="auto"
            onTimeUpdate={this.handleTimeUpdate.bind(this)}
            src={this.props.src}
            className={cn(css.video, (!this.state.loading ? css.show : ""))}
          >
            <source src={this.props.src}/>
          </video>
          <MuteButton onClick={this.toggleMuted.bind(this)} muted={this.props.muted}/>
          {this.state.loading && <VideoLoading
          videoThumb={this.props.thumb}/>}
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    muted:state.ui.video_muted
  }
}

export default connect(mapStateToProps)(Video);



// WEBPACK FOOTER //
// ./src/components/account_page/story_details/media/video.js